import MarkdownRenderer from "../Markdown/MarkdownRenderer";

const AidaDisclaimerContentFromMarkdown = () => {

    return (
        <div>
            <MarkdownRenderer file="/content/aida-disclaimer.md" />
        </div>
    );
};

export default AidaDisclaimerContentFromMarkdown;